import React, { useState, useEffect } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import Loader from "../../../components/Loader/Loader";
import { loginAPI } from "../services";
import { useNavigate } from "react-router-dom";
import { InputField } from "../../../components/InputField/InputField";
import Button from "../../../components/Button/Button";
import "./SignIn.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../../redux/slices/userSlice";
import { loginForm } from "../../DippingParameters/batchSlice";
import { pbkdf2Sync } from "crypto";
import { InputAdornment, TextField } from "@mui/material";
import { images } from "../../../config/images";

function SignIn({ onNextClick }) {
  const dispatch = useDispatch();

  // Initialize state variables
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [SignIncount, setSignIncount] = useState(0);
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaQuestion, setCaptchaQuestion] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [isKeepmelogin, setisKeepmelogin] = useState(true);

  // Use Navigate hook to change the route
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("Keepmelogin", isKeepmelogin);
  }, [isKeepmelogin]);

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const Tosterhandler = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handlekeepMeLogin = () => {
    setisKeepmelogin(!isKeepmelogin);
  };

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 50) + 10; // Random number between 10-60
    const num2 = Math.floor(Math.random() * 50) + 10; // Random number between 10-60
    setCaptchaQuestion(`${num1} + ${num2} =`);
    setCaptchaAnswer((num1 + num2).toString());
    setCaptchaValue("");
  };

  const handleSubmit = async () => {
    if(!email){
      Tosterhandler("Email is required");
      return;
    }
    if(!password){
      Tosterhandler("Password is required");
      return;
    }
    if (!captchaValue) {
      toast.error("Captcha is required");
      return;
    }

    // Verify captcha
    if (captchaValue !== captchaAnswer) {
      toast.error("Invalid captcha answer");
      generateCaptcha();
      return;
    }

    setLoading(true);

    function encryptPassword(password, salt, iterations) {
      const hash = pbkdf2Sync(
        password,
        salt,
        iterations,
        32,
        "sha256"
      ).toString("base64");
      const formattedHash = `pbkdf2_sha256$${iterations}$${salt}$${hash}`;
      return formattedHash;
    }

    const salt = "wUSaq3zAOY9ddYZNFDYqIr";
    const iterations = 320000;

    const encryptedPassword = encryptPassword(password, salt, iterations);

    const params = {
      email: email,
      password: encryptedPassword,
    };

    try {
      const resp = await loginAPI(params);

      if (resp.data.success == true) {
        setLoading(false);
        dispatch(
          setUserDetails({
            email: resp.data.payload.email,
            token: resp.data.payload.token,
            userPermission: resp.data.payload.module_permissions,
            is_superuser: resp.data.payload.is_superuser,
            is_admin: resp.data.payload.is_admin,
            is_manual_database_access:
              resp.data.payload.is_manual_database_access,
            is_upload_excel_access: resp.data.payload.is_upload_excel_access,
            is_remove_duplicates_access:
              resp.data.payload.is_remove_duplicates_access,
            user_role: resp.data.payload.user_role,
            user_role_name: resp.data.payload.user_role_name,
            username: resp.data.payload.username,
            is_production_line_access:
              resp.data.payload.is_production_line_access,
            is_supervisor: resp.data.payload.is_supervisor,
            unix_session_time: resp.data.payload.unix_session_time,
            is_tunnel_oven_access: resp.data.payload.is_tunnel_oven_access,
            is_db_export_access: resp.data.payload.is_db_export_access,
            is_hikar_team_access: resp.data.payload.is_hikar_team_access,
            is_gt_print_btn_access:resp.data.payload.is_gt_print_btn_access,
            userName: resp.data.payload.username,
          })
        );
        dispatch(
          loginForm({
            email: resp.data.payload.email,
            firstName: resp.data.payload.first_name,
            lastName: resp.data.payload.last_name,
            is_superuser: resp.data.payload.is_superuser,
            is_admin: resp.data.payload.is_admin,
            is_manual_database_access:
              resp.data.payload.is_manual_database_access,
            is_upload_excel_access: resp.data.payload.is_upload_excel_access,
            is_remove_duplicates_access:
              resp.data.payload.is_remove_duplicates_access,
            is_production_line_access:
              resp.data.payload.is_production_line_access,
            is_supervisor: resp.data.payload.is_supervisor,
            unix_session_time: resp.data.payload.unix_session_time,
            is_tunnel_oven_access: resp.data.payload.is_tunnel_oven_access,
            is_db_export_access: resp.data.payload.is_db_export_access,
            is_hikar_team_access: resp.data.payload.is_hikar_team_access,
            is_gt_print_btn_access:resp.data.payload.is_gt_print_btn_access,
            userName: resp.data.payload.username,
          })
        );

        navigate("/dashboard");
      } else {
        setLoading(false);
        Tosterhandler("Invalid Username and Password");
      }
    } catch (error) {
      setLoading(false);
      Tosterhandler("Invalid Username and Password");
      console.log(".........error found", error);
    }
  };

  const handleEmailChange = (event) => {
    const inputValue = event.target.value;
    setEmail(inputValue);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <div>
      <ToastContainer />
      <h3 className="form-login-title">Welcome</h3>
      <ValidatorForm>
        <InputField
          id="standard-basic"
          label="Email or Username"
          onChange={handleEmailChange}
          name="email"
          value={email}
          variant="standard"
        />
        
        <InputField
          id="standard-basic"
          name="password"
          type={showPassword ? "text" : "password"}
          label="Password"
          variant="standard"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                onClick={handleTogglePasswordVisibility}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  paddingRight: "8px",
                }}
              >
                {showPassword ? (
                  <img src={images.viewIconData} alt="" />
                ) : (
                  <img src={images.eyecloseIcon} alt="" />
                )}
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiInput-underline:before": {
              borderBottom: "1px solid rgba(0, 0, 0, 0.42) !important",
            },
          }}
        />

        <div className={`form-footer ${SignIncount > 2 ? "custom-margin" : ""}`}>
          <div className="keep-login-wrap">
            <input
              type="checkbox"
              id="keepMeLogin"
              name="keepMeLogin"
              value={isKeepmelogin}
              checked={isKeepmelogin}
              onChange={handlekeepMeLogin}
            />
            <label
              htmlFor="keepMeLogin"
              className={`keep-login-label ${
                SignIncount > 2 ? "custom-margin" : ""
              }`}
            >
              Keep me login
            </label>
          </div>
          <div className="forgot-link" onClick={onNextClick}>
            Forgot Password?
          </div>
        </div>
        <h6 style={{textAlign:"left", marginBottom:"0px"}}>Captcha Verification</h6>      
        <div className="captcha-container">
          <div className="d-flex gap-2" style={{background:"#f5f8ff", padding:"13px"}}>
          <div className="captcha-question">{captchaQuestion}</div>
          <TextField
            size="small"
            variant="outlined"
            value={captchaValue}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 4) {
                setCaptchaValue(value);
              }
            }}
            sx={{
              width: '100px',
              '& .MuiOutlinedInput-root': {
                height: '45px',
              }
            }}
          />
          <button
            type="button"
            className="reload-captcha-btn border-btn"
            onClick={generateCaptcha}
          >
            ↻
          </button>
          </div>
        </div>

        <Button
          type="submit"
          title="Login"
          className="common-button"
          onClick={handleSubmit}
        />

        {isLoading && <Loader />}
      </ValidatorForm>
    </div>
  );
}

export default SignIn;